import { render, staticRenderFns } from "./newOpen2.vue?vue&type=template&id=35db6387&scoped=true&"
import script from "./newOpen2.vue?vue&type=script&lang=js&"
export * from "./newOpen2.vue?vue&type=script&lang=js&"
import style0 from "./newOpen2.vue?vue&type=style&index=0&id=35db6387&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35db6387",
  null
  
)

export default component.exports